import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent, InputGroup, TextArea } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
// import * as _ from 'lodash';
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
// import slug from 'constants/slug';
import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import LoaiHoSoSelect from 'components/elements/select-loai-ho-so';
import { DateInput } from '@blueprintjs/datetime';
import { DATE_FORMAT } from 'config';
import moment from 'moment';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import { getDataForCustomSelect } from 'constants/custom-data';
import { COLOR } from 'config';
import { IS_ENTERPRISE } from 'config';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;
// @dynamicRoleHOC()
class FacilityeiaForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    facility: PropTypes.shape({
      _id: PropTypes.string,
      FacilityNameFull: PropTypes.string,
    }),
  };

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  setSelInitialBoolValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      return value + '';
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      value.IsCompleteDTM = value.IsCompleteDTM === 'true' ? true : false;
      value.IsEnvironmentalIncident =
        value.IsEnvironmentalIncident === 'true' ? true : false;
      value.facility = _.get(value.facility, 'value');
      value.Title = _.get(value.Title, 'value', undefined);
      console.log(value);
      if (error) return;
      if (this.props.handelSubmit) this.props.handelSubmit(value);
    });
  };

  render() {
    const { getFieldProps, getFieldError } = this.props.form;
    return (
      <div>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={this.submit}
                style={{ color: COLOR.SUCCESS }}
              />
              <Clearfix width={8} />
              {/* <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}> */}
              <Icon
                onClick={() => {
                  window.history.back();
                }}
                icon={IconNames.DISABLE}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.DANGER}
              />
              {/* </Link> */}
            </HeaderContainer>
          </Col>
        </Row>
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên hồ sơ
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <LoaiHoSoSelect
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'Title',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('Title')
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn tên hồ sơ',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('Title') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Số quyết định</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Số quyết định'
              {...getFieldProps('DecisionNumber', {
                initialValue: this.setInitialValue('DecisionNumber', ''),
                rules: [
                  {
                    min: 3,
                    max: 64,
                    message: 'Số quyết định có độ dài từ 3 -> 64 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('DecisionNumber') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Ngày phát hành <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày phát hành'
              {...getFieldProps('DateIssued', {
                initialValue: convertDate(
                  this.setInitialValue('DateIssued', null)
                ),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập ngày phát hành',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('DateIssued') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Cơ quan cấp</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Cơ quan cấp'
              {...getFieldProps('IssuingAgency', {
                initialValue: this.setInitialValue('IssuingAgency', ''),
                rules: [
                  {
                    min: 3,
                    max: 64,
                    message: 'Cơ quan cấp có độ dài từ 3 -> 64 kí tự',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('IssuingAgency') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                        value: this.props.facility._id,
                        label: this.props.facility.FacilityNameFull,
                      }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Tên cơ sở/dự án',
                    },
                  ],
                },
              }}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Tên doanh nghiệp</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  disabled
                  value={_.get(this.props.facility, 'organizationName', '')}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Ngành/Nghề</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              disabled
              value={_.get(this.props.facility, 'sector.Name', '')}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        {!IS_ENTERPRISE && (
          <React.Fragment>
            <Row>
              <Col xs={4}>
                <LabelContainer>Quận/Huyện</LabelContainer>
              </Col>
              <Col xs={4}>
                <InputGroup
                  disabled
                  value={_.get(this.props.facility, 'district.Name', '')}
                />
              </Col>
            </Row>
            <Clearfix height={8} />
          </React.Fragment>
        )}
        <Row>
          <Col xs={4}>
            <LabelContainer>Địa chỉ</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              disabled
              value={_.get(this.props.facility, 'Address1', '')}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Đường dẫn (URL)</LabelContainer>
          </Col>
          <Col xs={4}>
            <InputGroup
              placeholder='Đường dẫn (URL)'
              {...getFieldProps('EIAURL', {
                initialValue: this.setInitialValue('EIAURL', ''),
                rules: [
                  {
                    type: 'url',
                    message: 'Vui lòng nhập đúng định dạng http://example.com',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('EIAURL') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Ghi chú</LabelContainer>
          </Col>
          <Col xs={4}>
            <TextArea
              fill
              {...getFieldProps('Remarks', {
                initialValue: this.setInitialValue('Remarks', ''),
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(FacilityeiaForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityeiaContainer/FacilityeiaForm/index.js